import { IConversationParticipant, IAttachment, IConversationUser } from "../entities/conversation";
import { CategoryKey, CategoryTypeKey } from "../entities/deduction/remittance/RemittanceItem";

export interface MessagePayload {
  id: number;
  remittanceItemId: number;
  conversationId: number;
  requestUniqueKey: string;
  categoryKey: CategoryKey;
  referenceId: number;
  categoryTypeKey?: CategoryTypeKey;
  checkNumber: string;
  invoiceNumber: string;
  purchaserKey?: string;
  purchaserName?: string;
  participants: IConversationParticipant[];
  sender: IConversationUser;
  createdAt: string;
  isOwner: boolean;
  contentHtml: string | null;
  attachments: IAttachment[] | null;
  mentionedUsers: IConversationUser[];
}
export class NewConversationMessagePayload implements MessagePayload {
  private readonly _id: number;
  private readonly _remittanceItemId: number;
  private readonly _conversationId: number;
  private readonly _requestUniqueKey: string;
  private readonly _categoryKey: CategoryKey;
  private readonly _referenceId: number;
  private readonly _categoryTypeKey?: CategoryTypeKey;
  private readonly _checkNumber: string;
  private readonly _invoiceNumber: string;
  private readonly _purchaserKey?: string;
  private readonly _purchaserName?: string;
  private readonly _participants: IConversationParticipant[];
  private readonly _sender: IConversationUser;
  private readonly _createdAt: string;
  private readonly _isOwner: boolean;
  private readonly _contentHtml: string | null;
  private readonly _attachments: IAttachment[] | null;
  private readonly _mentionedUsers: IConversationUser[];

  constructor(data: MessagePayload) {
    this._id = data.id;
    this._remittanceItemId = data.remittanceItemId;
    this._conversationId = data.conversationId;
    this._requestUniqueKey = data.requestUniqueKey;
    this._categoryKey = data.categoryKey;
    this._referenceId = data.referenceId;
    this._categoryTypeKey = data.categoryTypeKey;
    this._checkNumber = data.checkNumber;
    this._invoiceNumber = data.invoiceNumber;
    this._purchaserKey = data.purchaserKey;
    this._purchaserName = data.purchaserName;
    this._participants = data.participants;
    this._sender = data.sender;
    this._createdAt = data.createdAt;
    this._isOwner = data.isOwner;
    this._contentHtml = data.contentHtml;
    this._attachments = data.attachments;
    this._mentionedUsers = data.mentionedUsers;
  }

  get id(): number {
    return this._id;
  }

  get remittanceItemId(): number {
    return this._remittanceItemId;
  }

  get conversationId(): number {
    return this._conversationId;
  }

  get requestUniqueKey(): string {
    return this._requestUniqueKey;
  }

  get referenceId(): number {
    return this._referenceId;
  }

  get categoryKey(): CategoryKey {
    return this._categoryKey;
  }

  get categoryTypeKey(): CategoryTypeKey | undefined {
    return this._categoryTypeKey;
  }

  get checkNumber(): string {
    return this._checkNumber;
  }

  get invoiceNumber(): string {
    return this._invoiceNumber;
  }

  get purchaserKey(): string | undefined {
    return this._purchaserKey;
  }

  get purchaserName(): string | undefined {
    return this._purchaserName;
  }

  get participants(): IConversationParticipant[] {
    return this._participants;
  }

  get sender(): IConversationUser {
    return this._sender;
  }

  get createdAt(): string {
    return this._createdAt;
  }

  get isOwner(): boolean {
    return this._isOwner;
  }

  get contentHtml(): string | null {
    return this._contentHtml;
  }

  get attachments(): IAttachment[] | null {
    return this._attachments;
  }

  get mentionedUsers(): IConversationUser[] {
    return this._mentionedUsers;
  }
}

export enum NotificationEvents {
  NEW_CONVERSATION_MESSAGE = "NEW_CONVERSATION_MESSAGE",
}

export interface INotificationEventsMap {
  [NotificationEvents.NEW_CONVERSATION_MESSAGE]: NewConversationMessagePayload;
}
